<button
  mat-button
  [class.selected]="(shopOrder$ | async)?.shippingAddressRegion"
  class="mat-display-1"
  [matTooltip]="((shopOrder$ | async)?.shippingAddress | shopAddress) ?? tooltip"
  matTooltipClass="accent"
>
  <fa-icon icon="map-pin" xIconSize="small"></fa-icon>

  @if (shopOrder$ | async; as order) {
    @if (order.shippingAddress && order.shippingAddressRegion) {
      <span class="street-label">{{ order.shippingAddress | shopAddress }}</span>
      <mat-chip class="mat-display-1 ms-auto" *ngIf="order.shippingAddressRegion.label as label">
        {{ label }}
      </mat-chip>
    } @else {
      <span i18n="@@Checkout.DeliveryArea">Delivery Area</span>
    }
  } @else {
    <span i18n="@@Checkout.DeliveryArea">Delivery Area</span>
  }
</button>
